export default "__VITE_ASSET__CIMHbWte__"